"use client";

import React from "react";
import { motion } from "framer-motion";
import Link from "next/link";

export const HeroSection = () => {
    return (
        <section className="relative min-h-screen flex flex-col items-center justify-center px-4 overflow-hidden py-40">
            {/* Minimal Visual Layer: Subtle Glow */}
            <div className="absolute inset-0 z-0 pointer-events-none">
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] bg-primary/5 rounded-full blur-[120px]" />
            </div>

            <div className="relative z-10 max-w-[1400px] w-full mx-auto text-center space-y-12">
                <div className="space-y-6">
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, delay: 0.1 }}
                        className="micro-id tracking-[0.4em] text-primary uppercase"
                    >
                        Execution is everything.
                    </motion.p>
                    <motion.h1 
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                        className="font-display leading-[1.1] text-[13vw] md:text-[11vw] tracking-tighter flex flex-col gap-8 md:gap-12"
                    >
                        <span>WE DON’T BUILD MVPS. </span>
                        <span className="text-muted-foreground/20 text-stroke">WE BUILD REAL PRODUCTS.</span>
                    </motion.h1>
                    
                    <motion.p 
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
                        className="text-xl md:text-2xl font-sans text-muted-foreground max-w-2xl mx-auto uppercase tracking-tighter"
                    >
                        From idea to production. Without wasted time.
                    </motion.p>
                </div>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.3, ease: [0.16, 1, 0.3, 1] }}
                >
                    <Link 
                        href="/contact"
                        className="px-12 py-6 bg-white text-black font-sans font-medium text-lg rounded-full hover:bg-white/90 transition-all hover:scale-105 active:scale-95 group relative overflow-hidden inline-block"
                    >
                        <span className="relative z-10">Start a Project</span>
                        <div className="absolute inset-0 bg-primary/20 translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
                    </Link>
                </motion.div>
            </div>
            
            {/* Subtle premium visual detail: Scroll indicator */}
            <motion.div 
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 1 }}
                className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4"
            >
                <span className="micro-id">Scroll to explore</span>
                <div className="w-[1px] h-12 bg-border relative overflow-hidden">
                    <motion.div 
                        animate={{ y: ["0%", "100%"] }}
                        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
                        className="absolute top-0 left-0 w-full h-1/2 bg-primary"
                    />
                </div>
            </motion.div>
        </section>
    );
};
